import BaseService from '@src/services/BaseService'

class AnswersService extends BaseService {
    constructor() {
        super('answers')
    }
}

export default new AnswersService()
